
        <div class="jui-select-wrap">
            <jui-dropdown trigger="click" [dataSource]="_dataSrc"
                [width]="width || minWidth"
                (selectChange)="valueSelected($event)"
                (getDropdownVisible)="getDropdownVisible($event)"
                [maxHeight]="maxHeight">
                <button jui-btn 
                    [disabled]="!enabled"
                    [class.width.px]="width"
                    [class.minWidth.px]="minWidth"
                    [class.height.px]="height"
                    btnEffect="useEffect?'spread':''">
                    <span class="txt">
                        {{_displayName || defaultName || '--'}}
                    </span>
                    <i class="iconfont" [ngClass]="iconCls" 
                        (click)="iconClicked($event)"></i>
                </button>
            </jui-dropdown>
        </div>
    